export default __webpack_public_path__ + "static/media/AIC LOGO BLACK.afb34695.svg";